import { render, staticRenderFns } from "./can.vue?vue&type=template&id=46c283b2&"
import script from "./can.vue?vue&type=script&lang=js&"
export * from "./can.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports